module.exports = __webpack_public_path__ + "static/media/arrownext.0bc12d8e.svg";